import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useMount } from 'react-use';
import { getManagerMode, getManagerRobotSerial } from '../common/util';
import NewPage from '../components/NewPage';
import { initialize } from '../modules/privateManager';
import CalendarPage from './CalendarPage';
import DiaryPage from './DiaryPage';
import HistoryPage from './HistoryPage';
import MessagePage from './MessagePage';
import PhotoPage from './PhotoPage';
import PrivateConfigPage from './PrivateConfigPage';

const MENU = [
  { name: 'config', label: '설정' },
  { name: 'msg', label: '메시지' },
  { name: 'photo', label: '포토' },
  { name: 'diary', label: '음성일기' },
  { name: 'calendar', label: '일정' },
  { name: 'history', label: '히스토리' },
];
const PrivateManagePage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [menu, setMenu] = useState('config');

  const handleChangeMenu = (event, m) => {
    setMenu(m);
  };

  useMount(() => {
    window.addEventListener('beforeunload', () => {
      dispatch(initialize());
    });
    if (!getManagerMode()) {
      history.replace('/signin');
    }
  });

  return (
    <NewPage title={`${getManagerRobotSerial()} 관리`}>
      <ToggleButtonGroup
        color="secondary"
        variant="outlined"
        onChange={handleChangeMenu}
        value={menu}
        exclusive
        fullWidth
      >
        {MENU.map(({ name, label }) => (
          <ToggleButton key={name} value={name}>
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {menu === 'config' && <PrivateConfigPage menu={menu} />}
      {menu === 'msg' && <MessagePage />}
      {menu === 'photo' && <PhotoPage />}
      {menu === 'diary' && <DiaryPage />}
      {menu === 'calendar' && <CalendarPage />}
      {menu === 'history' && <HistoryPage />}
    </NewPage>
  );
};

export default PrivateManagePage;
